import {getArgs} from './args.js';
import {lazy} from './lazy.js';

export const cond = (condition, thenAction, elseAction) => {
    return (...args) => {
        
        let _condition = lazy(condition, ...args);
        if (_condition) {
            return lazy(thenAction, ...args);
        } else {
            if (elseAction === undefined) {
                return args[0];
            }
            return lazy(elseAction, ...args);
        }
    };
};
